import { InputField, LabelField, MyRadioGroup } from "components";
import { useFormik } from "formik";
import { getAccessTokenSilently } from "utils/functions";
import { useSearch } from "hook";
import { AsyncAutoCompleteField } from "components/autoCompleteField/AsyncAutoField";
import AuthService from "Lib/API/Auth";
import MemberService from "Lib/API/Member";
import { toastr } from "react-redux-toastr";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";

import "./index.scss";
import { Fonts, FontColors } from "theme/fontConfig";

const NAME_MAX = 40;

const AddNewUserSchema = Yup.object().shape({
  first_name: Yup.string()
    .matches(/^[A-Za-z ]*$/, "Please enter a valid first name")
    .max(NAME_MAX, `First Name must be at most ${NAME_MAX} characters`)
    .required("First Name is required"),
  last_name: Yup.string()
    .matches(/^[A-Za-z ]*$/, "Please enter a valid last name")
    .max(NAME_MAX, `Last Name must be at most ${NAME_MAX} characters`)
    .required("Last Name is required"),
  permission: Yup.string().required("Required"),
  account: Yup.string().required("Required"),
});

const AddNewUser = ({ setOpen, refresh, setRefresh }) => {
  const [search, setSearch] = useState(undefined);
  const { searchAction } = useSearch({ action: setSearch });
  const [loading, setLoading] = useState(false);
  const [subLoading, setSubLoading] = useState(false);
  const [contactsList, setContactsList] = React.useState([]);

  const userId = localStorage.getItem("userId");
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: "",
      last_name: "",
      account: userId ? userId : "",
      permission: "member",
    },
    validationSchema: AddNewUserSchema,
    onSubmit: async (values) => {
      setSubLoading(true);
      const token = await getAccessTokenSilently();
      const input = {
        first_name: values.first_name,
        last_name: values.last_name,
        account_id: formik?.values?.account ? values.account : values.account,
        account_permission:
          values.permission === "member" ? "family_member" : "admin",
      };
      await AuthService.addNewMember(input, token)
        .then((res) => {
          setSubLoading(false);
          setOpen(false);
          setRefresh(!refresh);
          toastr.success("success", "Created New Member Successfully");
        })
        .catch((err) => {
          setSubLoading(false);
          console.log(err, "err");
          toastr.error("Error", err?.data?.message);
        });
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true);
      const token = await getAccessTokenSilently();
      await MemberService.getContacts(token, search)
        .then((res) => {
          if (res?.contacts) {
            res.contacts.map((item) => {
              item.id = item.member_id;
              item.label = item?.first_name + " " + item?.last_name;
              item.value = item._id;
              return item;
            });
            setContactsList(res?.contacts);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }

    if (!formik?.values?.account) fetchMyAPI();
  }, [search]);

  return (
    <div className="add-new-user">
      <div className="px-40">
        <p className="new-user-header mb-5">Add a family member</p>
        <InputField
          mandatory={true}
          {...{
            formik,
            title: "First Name",
            name: "first_name",
            placeholder: "David",
            checkValidation: true,
            maxLength: NAME_MAX,
          }}
        />
        <div style={{ fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.Slate94A3B8, textAlign: "right", marginTop: -12, marginBottom: 4 }}>
          {(formik.values.first_name || "").length}/{NAME_MAX}
        </div>
        <InputField
          mandatory={true}
          {...{
            formik,
            title: "Last Name",
            name: "last_name",
            placeholder: "Cohen",
            checkValidation: true,
            maxLength: NAME_MAX,
          }}
        />
        <div style={{ fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.Slate94A3B8, textAlign: "right", marginTop: -12, marginBottom: 4 }}>
          {(formik.values.last_name || "").length}/{NAME_MAX}
        </div>
        {!formik?.values?.account && (
          <div className="sm-12">
            <LabelField title="Account" mandatory={true} />
            <AsyncAutoCompleteField
              mandatory={true}
              {...{
                formik,
                name: "account",
              }}
              error={formik?.errors["account"]}
              touched={formik?.touched["account"]}
              onInputChange={(text) => searchAction(text)}
              classNamePrefix="react-select"
              options={contactsList}
              isLoading={loading}
              handleChange={(e) => formik.setFieldValue("account", e)}
              value={formik.values.account}
            />
          </div>
        )}
        <div className="py-5">
          <LabelField title="Account permission" />
          <MyRadioGroup
            row
            handleChange={(val) =>
              formik.setFieldValue &&
              formik.setFieldValue("permission", val.target.value)
            }
            value={formik.values.permission}
            name="permission"
            className="my-5"
            formsControls={[
              { value: "member", label: "Member" },
              { value: "admin", label: "Admin" },
            ]}
          />
        </div>
        <div
          className="form-group"
          style={{ textAlign: "center", marginBottom: "0px" }}
        >
          <button
            disabled={!formik.isValid}
            type="submit"
            className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
            onClick={() => formik.handleSubmit()}
          >
            <span style={{ fontSize: Fonts.GeneralSmallHeaderFont.fontSize, fontWeight: Fonts.GeneralSmallHeaderFont.fontWeight }}>
              Add to family
            </span>
            {subLoading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </div>
      </div>
    </div>
  );
};
export default AddNewUser;
